import { api } from './client';
import type { ActiveCloudRun, CheckMode, CloudRunStatus } from '@mycompbox/shared';
import type { Job } from './mailbox';

export type { ActiveCloudRun, CloudRunStatus };

/** What a cloud run would be for; lets the status also check the project's repository. */
export interface CloudRunTarget {
  epicRequestId?: string;
  epicId?: string;
}

export const cloudRunsApi = {
  status: (target: CloudRunTarget = {}) => {
    const params = new URLSearchParams();
    if (target.epicRequestId) params.set('epicRequestId', target.epicRequestId);
    if (target.epicId) params.set('epicId', target.epicId);
    const query = params.toString();
    return api.get<{ data: CloudRunStatus }>(`/cloud-runs/status${query ? `?${query}` : ''}`);
  },
  active: () => api.get<{ data: ActiveCloudRun[] }>('/cloud-runs/active'),
  start: (input: {
    kind: 'plan' | 'orchestrate' | 'refine';
    epicRequestId?: string;
    epicId?: string;
    /** Optional notes for a `refine` run (ENG-290). */
    notes?: string;
    /** Build runs only (ENG-430): whether to use fast mode. */
    fastMode?: boolean;
    /** Build runs only (ENG-430): a check-mode override; omitted means the project default. */
    checkMode?: CheckMode;
    /** Plan and build runs (ER-145): Autopilot carries on by itself in the cloud. */
    autopilot?: boolean;
  }) =>
    api.post<{ data: Job }>('/cloud-runs', input),
};
